import styled from 'styled-components';
import { getBreakpoint } from '$util/theme';
import Grid from '$components/layout/Grid';

export default styled(Grid)`
  background-color: #f4faff;
  h2 {
    font-size: 24px;
    color: #020202;
    text-align: center;
    margin-bottom: 30px;
    line-height: 29px;
    span {
      font-weight: 600;
    }
    @media (min-width: ${getBreakpoint('md')}) {
      line-height: 52px;
      font-size: 42px;
    }
  }
`;
